<script>
	import { onMount } from 'svelte';
	import Pbar from './Pbar.svelte';
	import Modal from './Modal.svelte';
	import Navbar from './Navbar.svelte';
	import PaymentIcons from './PaymentIcons.svelte';
	import CartLine from './CartLine.svelte';
	import Icon from './Icon.svelte';
	import { elasticOut } from 'eases-jsnext';
	import { fade, fly } from 'svelte/transition';
	import { querystring } from 'svelte-spa-router';
	import { step, type, beefCount, sweetCount, stepOld, typeOld, beefCountOld, sweetCountOld, country, savedOrder, ignoreSale } from './store.js';
	import { NotificationDisplay, notifier } from './index.js'


	country.useLocalStorage();
	// We reset all these ones
	step.useLocalStorage();
	type.useLocalStorage();
	beefCount.useLocalStorage();
	sweetCount.useLocalStorage();
	savedOrder.useLocalStorage();
	ignoreSale.useLocalStorage();

	onMount(() => {
		// Check if they have saved data, if so ask if they want to resume
		if ($savedOrder == true) {
			savePop = true;
			totalCount = $sweetCount + $beefCount;
			make(step, 1);
		}
		// Paint the scene on page load
		paint = true;
		// Check the query string, if bl or sp add a product there
		if ($querystring && $beefCount == 0 && sweetCount == 0) {
			let param = $querystring;
			if (param == 'bl') {
				preselect = true;
				plus(beefCount);
			} else if (param == 'sp') {
				preselect = true;
				plus(sweetCount);
			}
		}
	});
	
	//  I: Variables
	let domain,
			n,
			beefVariant,
			sweetVariant,
			magicLink,
			sale = false,
			salePopShown = false,
			discountAmt,
			discountPct,
			savePop = false,
			discount = 'None',
			discountName = 'Bark',
			loading = false,
			paymentMethods = [ 'Apple Pay', 'Google Pay', 'Visa', 'Mastercard', 'American Express', 'Shopify Pay' ],
			showModal = false,
			totalCount = 0,
			title = 'Your bud\'s new favorite treat!',
			titleSplit,
			subTitle = 'Select an option below to start your order.',
			minBundle = 3,
			maxCount = 12,
			leftCount,
			addGreen,
			quantity = 1,
			samples = [],
			ctaHover = false,
			returnProgress = 0,
			subStep = 1,
			upsellHeader = 'Want a Third Bag for $2.50?',
			upsellBody = 'We see you have 2 bags in the cart, adding another scores you free shipping and a seriously cheap 3rd bag!',
			hidden = false,
			pricePer = 9,
			sweetPricePer = 9,
			beefPricePer = 9,
			price,
			totalPrice,
			shippingCost = 0,
			lockstep2 = 'locked',
			lockstep3 = 'locked',
			paint = false,
			checkDelay = 75,
			preselect = false,
			cartFull = false,
			// Images
			blImg = './bl-main-new.png',
			blAlt = 'The Beef Lung Bag',
			spImg = './sp-main-new.png',
			spAlt = 'The Sweet Potato Bag',
			bmAlt = 'This button removes one Beef Lung Treat from your cart, but you have none in your cart',
			bpAlt = 'Add one Beef Lung Treat to your cart',
			sppAlt = 'Add one Sweet Potato Treat to your cart',
			smAlt = 'This button removes one Sweet Potato Treat from your cart, but you have none in your cart',
			smError = false,
			spError = false,
			bmError = false,
			bpError = false,
			sayCheese,
			grin = 'M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z',
			wink = 'M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z',
			blPlace = 'data:image/jpeg;base64,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',
			spPlace = 'data:image/jpeg;base64,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',
			blThumb = 'data:image/png;base64,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',
			spThumb = 'data:image/png;base64,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';

	// II: Computed
	$: 	// Country switch
		 	domain = $country == 'ca' ? 'healthybud.myshopify.com' : 'healthybud-us.myshopify.com',
		 	beefVariant = $country == 'ca' ? '15820288524351' : '30905978912853',
			sweetVariant = $country == 'ca' ? '30267634516031' : '30905978847317',

			// Link builder
			magicLink = `https://${domain}/cart/${$beefCount > 0 ? beefVariant + ':' + $beefCount : ''}${$beefCount > 0 && $sweetCount > 0 ? ',' : ''}${$sweetCount > 0 ? sweetVariant + ':' + $sweetCount : ''}${discount != 'None' ? '?discount=' + discount : ''}`,

		 	// Find out how many total are in cart
			totalCount = $sweetCount + $beefCount,
				
		 	// Find out how many are left in a bundle
			leftCount = maxCount - totalCount,

		 	// Calculate shipping cost
		 	shippingCost = $type == 'sample' ? 5 : 0,

			// Calculate subtotal for products
			price = sweetPricePer * $sweetCount + beefPricePer * $beefCount,

			// Discount calculations
			
			discountPct = !sale || totalCount < 3 ? 0 :
									totalCount < 6 ? .2 :
									totalCount < 10 ? .3 :
									.4,
			discountAmt = price * discountPct,

			// Calculate total price
			totalPrice = price + shippingCost - discountAmt,

			// Make sure the right code gets applied
			discount = totalCount > 2 && sale ? `${discountName}${discountPct * 100}` : 'None',
	
			// Make things go green when the bundle is completed
			addGreen = (leftCount == 0 && $step == 1 && $type == 'bundle') ? 'gtg' : '',

			// Set title & subtitle

			title = $step == 0 ? 'Your bud\'s new favorite treat!' :
							$step == 1 ? $type == 'bundle' ? 'What can we send your bud?' : 'What does your bud want to try?' :
							$step == 2 ? 'A Quick Review' : '',
			subTitle = $step == 0 ? 'Select an option below to start your order.' :
								$step == 1 ? $type == 'bundle' ? leftCount != 0 ? 'Use the + button to add items to your cart' : 'Cart is Full' : 'You can choose one of each, click next when you\'re ready' :
								$step == 2 ? 'Make sure everything looks right before checking out' : '',

			// Change the upsell text on the modal to match the step
		 	upsellHeader = subStep == 1 ? 'Add a Third Bag for $4?' : 'Great! Pick a Third Bag',
			upsellBody = subStep == 1 ? 'We see you have 2 bags in the cart, adding another scores you free shipping!' : 'Make a selection below to review your purchase before heading to checkout.',

			// Progress bar
			returnProgress = $step / 2,
 
			// Wink hover
			sayCheese = ctaHover ? wink : grin;

	// Let's figure out if those nav numbers should be locked up or not (we don't want people going where they shouldn't be going)
	$: if ($step == 0) {
		if ($type == null) {
			// So here nothing has been done, this is fresh so let's lock both
			lockstep2 = 'locked';
			lockstep3 = 'locked';
		} else {
			// Now they at least chose an option on step 1, let's open up step 2 and check if step 3 is valid yet
			lockstep2 = 'unlocked';

			if ($type == 'bundle') {
				// So they have bundle selected, step 2 is already open for them, let's check if 3 is locked for a bundle they can only check out if they have at least 3 selected products
				if (totalCount < minBundle) {
					lockstep3 = 'locked';
				} else {
					lockstep3 = 'unlocked';
				}
			} else {
				// They have sample selected, once they have one or more selected they should be allowed to go where they want... right?
				if (totalCount == 0) {
					lockstep3 = 'locked';
				} else {
					lockstep3 = 'unlocked';
				}
			}
		}
	} else if ($step == 1) {
		lockstep2 = 'unlocked';
		if ($type == 'bundle') {
			// So they have bundle selected, step 2 is already open for them, let's check if 3 is locked for a bundle they can only check out if they have 3 selected products
			if (totalCount < minBundle) {
				lockstep3 = 'locked';
			} else {
				lockstep3 = 'unlocked';
			}
		} else {
			// They have sample selected, once they have one or more selected they should be allowed to go where they want... right?
			if (totalCount == 0) {
				lockstep3 = 'locked';
			} else {
				lockstep3 = 'unlocked';
			}
		}
	} else {
		lockstep2 = 'unlocked';
		lockstep3 = 'unlocked';
	}

	// III: Functions
	function saveOrder() {
		make(savedOrder, true);
		loading = true;
	}
	function startOver() {
		make(savedOrder, false);
		make(step, 0);
		make(beefCount, 0);
		make(sweetCount, 0);
		make(type, null);
	}
	function pickUp() {
		savePop = false;
		make(savedOrder, false);
	}
	// Utility functions for numbers
	function plus(value) {
		value.update(n => n + 1);
	}
	function minus(value) {
		value.update(n => n - 1);
	}
	function reset(value) {
		value.set(0);
	}
	function make(value, amt) {
		value.set(amt);
	}
	function switchIt() {
		if ($country == 'ca') {
			country.set('us');
			console.log('Hello Usa');
			notifier.danger('Country switched to USA', 3000)

		} else if ($country == 'us') {
			country.set('ca');
			console.log('Hello Canada');
			notifier.danger('Country switched to Canada', 3000)

		}
	}

	// Tell them something when they try to fill the bundle too much
	function throwFullError() {
		cartFull = true;
		showModal = true;
	}

	// Tell them something when they try to fill the bundle too much
	function throwEmptyError() {
		// nothing here yet... do we want to do something else
	}

	// Let them select individual products
	function selectBeef() {
		if ($beefCount == 0) {
			make(beefCount, 1);
		} else {
			reset(beefCount);
		}		
	}

	function selectSweet() {
		if ($sweetCount == 0) {
			make(sweetCount, 1);
		} else {
			reset(sweetCount);
		}		
	}

	// They're about to checkout with their samples, let's make sure they don't need to get hit with the ol' upsell
	function upsell() {
		if (totalCount > 1) {
			showModal = true;
		} else {
			plus(step);
		}
	}
	
	// They denied the upsell, take them to the review
	function checkOut() {
		hideShow();
		showModal = false;
		plus(step);
	}

	// They said yes, add to the substep to advance the modal
	function updateCart() {
		subStep += 1;
	}

	// They chose a taster let's reset all the counts
	function sampleFlow() {
		if ($type == 'bundle' || $type == null) {
			if (preselect) {
				make(type, 'sample');
				preselect = false;
				nextStep();
			} else {
				reset(beefCount);
				reset(sweetCount);
				make(type, 'sample');
				nextStep();
			}
		} else if ($type == 'bundle') {
			nextStep();
		}
	}

	// They chose a bundle let's reset all the counts unless they had already chosen the bundle in which case lets keep some info about their interaction so far
	function bundleFlow() {
		if ($type == 'sample' || $type == null) {
			if (preselect) {
				make(type, 'bundle');
				preselect = false;
				nextStep();
			} else {
				reset(beefCount);
				reset(sweetCount);
				make(type, 'bundle');
				nextStep();
			}
		} else if ($type == 'bundle') {
			nextStep();
		}
	}
	
	// Increment/decrement step (self-documenting)
	function nextStep() {
		plus(step);
	}
	function prevStep() {
		minus(step);
	}

	// They took the upsell, now they're either going to add another beef or another sweet, let's plan for both
	function beefCheckout() {
		make(type, 'bundle');
		hideShow();
		plus(beefCount);
		nextStep();
		subStep = 1;
	}
	function sweetCheckout() {
		make(type, 'bundle');
		hideShow();
		plus(sweetCount);
		nextStep();
		subStep = 1;
	}

	// Control the discount notice here
	function discountNotice() {
		if (totalCount == 2 && sale) {
			notifier.success('20% off discount unlocked, keep adding items to unlock more discounts', 3000);
		} else if (totalCount == 5 && sale) {
			notifier.success('Nice! 30% off discount unlocked', 3000);
		} else if (totalCount == 9 && sale) {
			notifier.success('Sweet! 40% off discount unlocked', 3000);
		}
	}

	// One point to house beefendor
	function beefPlus() {
		if (totalCount < maxCount) {
			bpError = false;
			bpAlt = 'Add one Beef Lung Treat to your cart';
			plus(beefCount);
			discountNotice();
		} else {
			bpError = true;
			setTimeout(() => bpError = false, 500);
			bpAlt = 'This button adds one Beef Lung Treat to your cart, but your bundle is full';
			throwFullError();
		}		
	}
	function beefMinus() {
		if ($beefCount != 0) {
			bmError = false;
			bmAlt = 'Remove one Beef Lung Treat from your cart';
			minus(beefCount);
		} else {
			bmError = true;
			setTimeout(() => bmError = false, 500);
			bmAlt = 'This button removes one Beef Lung Treat from your cart, but you have none in your cart';
			throwEmptyError();
		}		
	}

	// One point to house sweeteryn
	function sweetPlus() {
		if (totalCount < maxCount) {
			spError = false;
			sppAlt = 'Add one Sweet Potato Treat to your cart';
			plus(sweetCount);
			discountNotice();
		} else {
			spError = true;
			setTimeout(() => spError = false, 500);
			sppAlt = 'This button adds one Sweet Potato Treat to your cart, but your bundle is full';
			throwFullError();
		}		
	}
	function sweetMinus() {
		if ($sweetCount != 0) {
			smError = false;
			smAlt = 'Remove one Sweet Potato Treat from your cart';
			minus(sweetCount)
		} else {
			smError = true;
			setTimeout(() => smError = false, 500);
			smAlt = 'This button removes one Sweet Potato Treat from your cart, but you have none in your cart';
			throwEmptyError();
		}
	}

	// Hide products slide for a smoother transition to the summary slide
	function hideShow() {
		hidden = true;
		checkDelay = 250;
		setTimeout(() => checkDelay = 75, 2000);
		setTimeout(() => hidden = false, 2000);
	}
	// They don't want to see the sales notifications anymore
	function stopPlz() {
		salePopShown = true;
		make(ignoreSale, true);
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}

	.grid-a {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 40px max-content max-content max-content;
		grid-gap: 30px;
		justify-items: center;
		padding: 10px 0 20px;
		grid-template-areas:
			"s"
			"h"
			"m"
			"c"
	}

	.step-counter {
		display: grid;
		grid-template-columns: 40px 40px 40px;
		grid-gap: 50px;
		text-align: center;
		justify-items: center;
		grid-area: s;
	}
	.email-us {
		color: #598cd8;
    font-weight: bold;
    letter-spacing: 1px;
	}
	.step {
		display: grid;
		align-content: center;
		justify-content: center;
		text-align: center;
		font-size: 18px;
		border-radius: 50px;
		height: 40px;
		width: 40px;
		cursor: pointer;
		font-weight: 900;
		padding: 0;
		margin: 0;
		color: #666;
		background: #fff;
		position: relative;
	}

	.active-step {
		background: #58CFEB;
		color: #fff;
		border: 0;
	}

	.locked {
		pointer-events: none;
		color: #bcbcd5;
	}
	* {
			-webkit-touch-callout: none;
			-webkit-user-select: none;
			-khtml-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;
			-webkit-tap-highlight-color: transparent
	}
	button.active-step:focus, button.active-step:hover {
    background: #58CFEB;
		color: #fff;
	}

	button.active-step:focus::after {
    top: 0;
		left: 0;
		border-color: #FFB961;
		border-width: 3px;
	}

	.header-block {
		text-align: center;
	}

	.header {
		grid-area: h;
		margin-bottom: 0;
	}

	.subheader {
		border-radius: 0.5rem;
		padding: .5rem .75rem;
		margin: 0 auto;
	}

	main {
		grid-area: m;
		width: 100%;
		grid-gap: 10px 40px;
		justify-content: center;
		display: grid;
		grid-template-columns: repeat(auto-fit, 250px);
	}

	main.confirmation {
		grid-template-columns: 1fr;
	}

	.main-cta {
		grid-area: c;
		width: 200px;
    justify-self: center;
	}

	.gtg {
		background: #d2feea;
		max-width: 80px;
	}
	
	.option {
		align-self: end;
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 75px 40px 1fr 80px;
		grid-gap: 0px;
		text-align: center;
		background: #fff;
		height: 250px;
		width: 250px;
		border-radius: 0.75rem;
		box-shadow: 0 3px 6px rgba(27,37,38,.16);
		transition: all .3s ease;
		padding-top: 10px;
	}

	.option.selectable:hover {
		box-shadow: 0 6px 10px rgba(27,37,38,.20);
		cursor: pointer;
	}

	.quantity {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 40px 331px 50px;
		grid-gap: 10px;
		text-align: center;
		background: #fff;
		width: 250px;
		transition: all .3s ease;
		padding-top: 10px;
		justify-content: center;
	}

	.quantity-img {
		width: 100%;
		position: relative;
		grid-area: 2 / 1 / 3 / 2;
	}

	.quantity-img img {
		max-width: 85%;
	}

	.place-img {
		width: 100%;
		position: relative;
		grid-area: 2 / 1 / 3 / 2;
	}

	.place-img img {
		max-width: 85%;
	}

	.option svg {
		max-height: 70px;
	}

	.option-button {
		border-radius: 0.5rem;
		border: 0;
		margin: 10px;
		cursor: pointer;
		font-weight: bold;
		color: #494025;
		font-size: 18px;
		position: relative;
		background: #FFB961;
		transition: all .3s ease;
		padding: 1.125rem;
	}

	.option-button:hover, .option:hover button, .option-button:focus {
		background: #fec988;
	}

	.magic-button {
		border-radius: 0.5rem;
    border: 0;
    cursor: pointer;
    font-weight: bold;
    color: #494025;
    font-size: 18px;
    padding: 1.25rem;
    background: #FFB961;
    transition: all .3s ease;
	}

	.magic-button:hover, .option:hover button {
		background: #fec988;
	}

	.active-opt button {
		background: #58CFEB
	}

	.option.active-opt:hover button {
		background: #58CFEB
	}

	.active-opt {
		box-shadow: none;
		border: 4px solid;
		border-color: #00ceff;
		animation: pulse 2.5s linear infinite;
	}
	
	.option.selectable.active-opt:hover {
		box-shadow: none;
	}
	
	.counter-block {
		display: grid;
		grid-template-columns: repeat(3, 60px);
		justify-self: center;
		font-size: 24px;
		font-weight: 900;
		color: #666;
		align-items: center;
		grid-gap: 5px;
	}

	.counter-block p {
		background: #fff;
		border: 1px solid #efefef;
		height: 100%;
		display: grid;
		align-content: center;
		border-radius: 0.5rem;
	}

	.counter-block button {
		border-radius: 0.5rem;
		cursor: pointer;
		border: 0;
		background: #fff;
		transition: all .2s ease;
		height: 60px;
	}

	.counter-block button:hover {
		background: #f4f4f4;
	}

	.checkboxes {
		cursor: pointer;
	}

	.check-block {
		background: #fff;
		cursor: pointer;
		width: 70px;
		margin: 0 auto;
		border: none;
	}

	.check-block svg {
		height: 70px;
		width: 70px;
	}

	button.check-block {
		position: relative;
	}

	button.check-block:after {
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    background: #95e692;
    opacity: .5;
    border-radius: 50px;
    top: 50%;
    left: 50%;
		transform: translate(-50%, -50%);
		transition: all .3s ease-in;
	}

	button.check-block.checked:after {
    height: 100px;
    width: 100px;
		opacity: 0;
		transition: all .5s ease-out;
	}

	.modal-header {
		color: #3d4a4b;
	}

	.modal-body {
		padding: 1.5rem 0 2.25rem;
	}

	ul {
		display: block;
		background: #efefef;
		border-radius: 0.5rem;
		padding: 0;
		list-style: none;
		overflow: hidden;
	}

	.summary {
		padding: .5rem;
		display: grid;
		grid-gap: 15px;
		min-width: 260px;
		margin: 0 auto;
		text-align: center;
	}
	table {
			background: #f4f4f4;
			border-radius: 0.5rem;
			overflow: hidden;
			border: none;
			border-collapse: collapse;
			margin-bottom: 15px;
			max-height:111px;
			width: 100%;
	}
	td.table-key {
    font-weight: bold;
    text-align: left;
    padding: 0.5rem;
	}

	td.table-val {
    text-align: right;
    padding: 0.5rem !important;
	}
	tr.total {
		background: #ffdfb8;
	}
	tr.discount {
		background: #c3fbc5;
	}
	@keyframes pulse {
		0% {
			border-color: #00ceff;
		}
		50% {
			border-color: #a8eefe;
		}
		100% {
			border-color: #00ceff;
		}
	}

	@media (min-width: 992px) {
		.option {
			height: 310px;
			grid-template-rows: 100px 40px 1fr 80px;
			grid-gap: 10px;
		}
		.option svg {
			max-height: 100px;
			margin: 0 auto;
		}
		main {
			grid-gap: 10px 80px;
		}
		.quantity-img img {
			max-width: 90%;
		}
	}
</style>

<NotificationDisplay close={true} bind:this={n} />

{#if sale && !salePopShown && !savePop && paint && !$ignoreSale}
	<Modal muted={true} lang={false} cta={false} saved={false} salepop={true} on:close={() => salePopShown = true} on:ignore={stopPlz}>
	<h2 class="modal-header" slot="header">
					🎉🐶Happy Bark Friday!🐶🎉
				</h2>
				<p class="modal-body">
					Healthybud Bark Friday quantity discounts are live until 11:59 pm ET Monday December 9th!
				</p>
	</Modal>
{/if}

{#if $savedOrder && savePop}
	<Modal muted={true} lang={false} cta={false} saved={true} on:reset={startOver} on:resume={pickUp}>
	<h2 class="modal-header" slot="header">
					Welcome back!
				</h2>
				<p class="modal-body">
					We saved your cart, what would you like to do?
				</p>
	</Modal>
{/if}

{#if $country == null && $step == 2}
	<Modal muted={true} lang={true} cta={false} on:canada={() => make(country, 'ca')} on:usa={() => make(country, 'us')}>
	<h2 class="modal-header" slot="header">
					Where should we send your order?
				</h2>
				<p class="modal-body">
					Click or tap a country name below
				</p>
	</Modal>
{/if}

{#if $step == 1 && $type == 'sample'}
	{#if showModal && totalCount == 2}
		<Modal muted={true} cta={true} mstep="{subStep}" on:close="{checkOut}" on:update="{updateCart}" on:beefup="{beefCheckout}" on:sweetup="{sweetCheckout}">
				<h2 class="modal-header" slot="header">
					{upsellHeader}
				</h2>
				<p class="modal-body">
					{upsellBody}
				</p>
		</Modal>
	{/if}
{/if}

{#if $step == 1 && $type == 'bundle'}
	{#if showModal && cartFull == true}
		<Modal muted={true} cta={false} on:close="{() => showModal = false}">
				<h2 class="modal-header" slot="header">
					Woah, that's a tall order!
				</h2>
				<p class="modal-body">
					Let's get in touch so we can save you some money with bulk pricing. Drop us a line here -> <a class="email-us" target="_blank" href="mailto:yourfriends@healthybud.co?subject=My Healthybud Bulk Order!&body=Hi, I'd like to order a lot of delicious, healthy treats for my furry baby!">yourfriends@healthybud.co</a>
				</p>
		</Modal>
	{/if}
{/if}


<Pbar amt="{returnProgress}"></Pbar>
<Navbar on:switchCountry={switchIt} blimg={blThumb} spimg={spThumb} count="{totalCount}" cost="{price}" bc="{$beefCount}" sc="{$sweetCount}"></Navbar>
<div class="grid-a">
	{#if paint}
	<div class="step-counter" in:fly="{{ y: 20, duration: 1000, delay: 5, easing: elasticOut }}">
		<button aria-label="{$step == 0? 'Step 1, this step is active' : 'Press spacebar to go to step 1'}" on:click="{() => reset(step)}" class="step step-one {$step == 0? 'active-step' : ''}">
			1
		</button>
		<button aria-label="{$step == 1? 'Step 2, this step is active' : 'Press spacebar to go to step 2'}" on:click="{() => make(step, 1)}" class="step step-two {lockstep2} {$step == 1? 'active-step' : ''}">
			2
		</button>
		<button aria-label="{$step == 2? 'Step 3, this step is active' : 'Press spacebar to go to step 3'}" on:click="{() => make(step, 2)}" class="step step-three {lockstep3} {$step == 2? 'active-step' : ''}">
			3
		</button>
	</div>
	{/if}
	{#if paint}
	<div class="header-block" in:fly="{{ y: 20, duration: 1000, delay: 25, easing: elasticOut }}">
		<h1 class="header">
			{title}
		</h1>
		<p class="subheader {addGreen}">
			{@html subTitle}
		</p>
	</div>
	{/if}
	<main class="{$step == 2? 'confirmation' : ''}">

	{#if $step == 0 && paint}
		<div
			role="button"
			aria-label="This option fills your cart with single products at $9 a bag with $5 shipping. Press space to select this option."
			class="option option-a selectable {$type == 'sample'? 'active-opt' : ''}"
			on:click={sampleFlow}
			in:fly="{{ y: 20, duration: 1000, delay: 50, easing: elasticOut }}"
			>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450.7 438"><style>.st0{fill:#ffb3ae}.st1{fill:#fff;stroke:#231f20;stroke-width:8;stroke-miterlimit:10}</style><path d="M413.4 397.9H37.2C16.8 397.9 0 381.2 0 360.7V63.8c0-20.5 16.8-37.2 37.2-37.2h376.2c20.5 0 37.2 16.8 37.2 37.2v296.9c.1 20.5-16.7 37.2-37.2 37.2z" class="st0"/><path d="M364.3 56.6V4H86.1v52.6H364zM86.1 434c31.1-54 31.7-345.7 0-377.4C49.7 93 55.8 403.7 86.1 434H364c35.4-35.4 33-344.4 0-377.4H86.1" class="st1"/><g><path d="M301.1 282.1c0 26.4-21.4 21-47.9 21s-47.9 5.4-47.9-21 21.4-47.9 47.9-47.9 47.9 21.5 47.9 47.9zM243.6 196.2c.5 8.7-5.5 16.1-13.3 16.5-7.8.4-14.5-6.3-14.9-15-.5-8.7 5.5-16.1 13.3-16.5 7.8-.5 14.5 6.3 14.9 15zM291 196.5c-.5 8.7-7.3 15.4-15.1 14.9s-13.7-7.9-13.2-16.6c.5-8.7 7.3-15.4 15.1-14.9 7.9.5 13.8 7.9 13.2 16.6zM330.5 229.5c-3 8.2-11.3 12.7-18.7 10-7.3-2.7-10.9-11.5-7.9-19.7s11.3-12.7 18.7-10c7.3 2.7 10.8 11.5 7.9 19.7zM175.7 230.4c2.9 8.2 11.2 12.8 18.6 10.2 7.4-2.6 11-11.4 8.1-19.6-2.9-8.2-11.2-12.8-18.6-10.2-7.3 2.6-11 11.4-8.1 19.6z" class="st0"/></g></svg>
			<h2>
				Just a Taste
			</h2>
			<p>
				$9/bag + $5 shipping
			</p>
			<button class="option-button option-a-button">
				{$type == 'sample'? 'Selected ✔' : 'Try a bag'}
			</button>
		</div>
		
		<div
		 	role="button"
			aria-label="This option fills your cart with a Bud Bundle at $9 a bag with free shipping. Press space to select this option."
			class="option option-b selectable {$type == 'bundle'? 'active-opt' : ''}"
			on:click="{bundleFlow}"
			on:mouseenter="{()=> ctaHover = true}"
			on:mouseleave="{()=> ctaHover = false}"
			in:fly="{{ y: 20, duration: 1000, delay: 75, easing: elasticOut }}"
			>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 478.8 438.7"><style>.st2{fill:#92e1be}.st3{fill:#fff;stroke:#231f20;stroke-width:8;stroke-miterlimit:10}</style><path d="M428.8 395H52.6c-20.5 0-37.2-16.8-37.2-37.2v-297c0-20.5 16.8-37.2 37.2-37.2h376.2c20.5 0 37.2 16.8 37.2 37.2v296.9c0 20.5-16.7 37.3-37.2 37.3z" class="st2"/><path d="M222.4 41.9V4H22v37.9h200.2z" class="st3"/><path d="M22 313.7c22.4-38.9 22.8-249 0-271.8-26.2 26.2-21.8 250 0 271.8h200.2c25.5-25.5 23.8-248.1 0-271.8H22" class="st1"/><path d="M176.9 204.3c0 19-15.4 15.2-34.5 15.2s-34.5 3.9-34.5-15.2 15.4-34.5 34.5-34.5 34.5 15.5 34.5 34.5zM135.5 142.4c.3 6.3-4 11.6-9.6 11.9-5.6.3-10.4-4.5-10.8-10.8-.3-6.3 4-11.6 9.6-11.9 5.7-.3 10.5 4.5 10.8 10.8zM169.7 142.7c-.4 6.3-5.2 11.1-10.9 10.7-5.6-.3-9.9-5.7-9.5-12 .4-6.3 5.2-11.1 10.9-10.7 5.6.4 9.8 5.7 9.5 12zM198.1 166.4c-2.1 5.9-8.2 9.1-13.5 7.2-5.3-1.9-7.8-8.3-5.7-14.2 2.1-5.9 8.2-9.1 13.5-7.2 5.3 2 7.8 8.3 5.7 14.2zM86.6 167.1c2.1 5.9 8.1 9.2 13.4 7.3 5.3-1.9 7.9-8.2 5.8-14.1-2.1-5.9-8.1-9.2-13.4-7.3-5.3 1.8-7.9 8.2-5.8 14.1z" class="st2"/><g><path d="M340.8 92.3V54.4H140.4v37.9h200.2zM140.4 364.1c22.4-38.9 22.8-249 0-271.8-26.2 26.2-21.8 250 0 271.8h200.2c25.5-25.5 23.8-248.1 0-271.8H140.4" class="st3"/><g><path d="M295.3 254.7c0 19-15.4 15.2-34.5 15.2s-34.5 3.9-34.5-15.2 15.4-34.5 34.5-34.5 34.5 15.5 34.5 34.5zM253.9 192.8c.3 6.3-4 11.6-9.6 11.9-5.6.3-10.4-4.5-10.8-10.8-.3-6.3 4-11.6 9.6-11.9 5.6-.3 10.5 4.6 10.8 10.8zM288 193.1c-.4 6.3-5.2 11.1-10.9 10.7-5.6-.3-9.9-5.7-9.5-12 .4-6.3 5.2-11.1 10.9-10.7 5.7.4 9.9 5.7 9.5 12zM316.4 216.9c-2.1 5.9-8.2 9.1-13.5 7.2-5.3-1.9-7.8-8.3-5.7-14.2 2.1-5.9 8.2-9.1 13.5-7.2 5.3 1.9 7.9 8.3 5.7 14.2zM205 217.5c2.1 5.9 8.1 9.2 13.4 7.3 5.3-1.9 7.9-8.2 5.8-14.1-2.1-5.9-8.1-9.2-13.4-7.3-5.3 1.9-7.9 8.2-5.8 14.1z" class="st2"/></g></g><g><path d="M456.6 162.9V125H256.2v37.9h200.1z" class="st3"/><path d="M256.2 434.7c22.4-38.9 22.8-249 0-271.8-26.2 26.2-21.8 250 0 271.8h200.2c25.5-25.5 23.8-248.1 0-271.8H256.2" class="st3"/><g><path d="M411.1 325.3c0 19-15.4 15.2-34.5 15.2s-34.5 3.9-34.5-15.2 15.4-34.5 34.5-34.5 34.5 15.5 34.5 34.5zM369.7 263.4c.3 6.3-4 11.6-9.6 11.9-5.6.3-10.4-4.5-10.8-10.8-.3-6.3 4-11.6 9.6-11.9 5.6-.3 10.4 4.6 10.8 10.8zM403.8 263.7c-.4 6.3-5.2 11.1-10.9 10.7-5.6-.3-9.9-5.7-9.5-12 .4-6.3 5.2-11.1 10.9-10.7 5.6.4 9.9 5.7 9.5 12zM432.2 287.5c-2.1 5.9-8.2 9.1-13.5 7.2-5.3-1.9-7.8-8.3-5.7-14.2 2.1-5.9 8.2-9.1 13.5-7.2 5.3 1.9 7.9 8.3 5.7 14.2zM320.7 288.1c2.1 5.9 8.1 9.2 13.4 7.3 5.3-1.9 7.9-8.2 5.8-14.1-2.1-5.9-8.1-9.2-13.4-7.3-5.2 1.9-7.8 8.2-5.8 14.1z" class="st2"/></g></g></svg>
			<h2>
				A Bud Bundle
			</h2>
			<p>
				$9/bag + FREE Shipping
			</p>
			<button class="option-button option-b-button">
				{@html $type == 'bundle'? 'Selected ✔' : `Get a box of 3+ <svg style="position: absolute;top:15px;right:10px;" aria-hidden="true" height="30" viewBox="0 0 496 512"><path fill="currentColor" d="${sayCheese}"/></svg>`}
			</button>
		</div>
	{/if}

	{#if $step == 1 && $type == 'bundle' && !hidden}
		<div class="quantity" in:fly="{{ y: 20, duration: 1000, delay: 50, easing: elasticOut }}">
			<h2>
				Beef Lung
			</h2>
			<div class="place-img">
				<img src="{blPlace}" alt="{blAlt}" draggable="false"/>
			</div>
			<div class="quantity-img">
				<img src="{blImg}" alt="{blAlt}" draggable="false"/>
			</div>
			<div class="counter-block">
				<button aria-label="{bmAlt}" class="minus {bmError? 'error' : 'good'}" on:click={beefMinus}>
					<Icon color="blue" icon="minus"></Icon>
				</button>
					<p>
						{$beefCount}
					</p>
				<button aria-label="{bpAlt}" class="plus {bpError? 'error' : 'good'}" on:click={beefPlus}>
					<Icon color="blue" icon="plus"></Icon>
				</button>
			</div>
		</div>
		<div class="quantity" in:fly="{{ y: 20, duration: 1000, delay: 75, easing: elasticOut }}">
			<h2>
				Sweet Potato
			</h2>
			<div class="place-img">
				<img src="{spPlace}" alt="{spAlt}" draggable="false"/>
			</div>
			<div class="quantity-img">
				<img src="{spImg}" alt="{spAlt}" draggable="false"/>
			</div>
			<div class="counter-block">
				<button aria-label="{smAlt}" class="minus {smError? 'error' : 'good'}" on:click={sweetMinus}>
					<Icon color="blue" icon="minus"></Icon>
				</button>
				<p>
					{$sweetCount}
				</p>
				<button aria-label="{sppAlt}" class="plus {spError? 'error' : 'good'}" on:click={sweetPlus}>
					<Icon color="blue" icon="plus"></Icon>
				</button>
			</div>
		</div>
	{/if}

		{#if $step == 1 && $type == 'sample'}
			{#if !hidden}
				<div class="quantity checkboxes" in:fly="{{ y: 20, duration: 1000, delay: 50, easing: elasticOut }}" on:click="{selectBeef}">
					<h2>
						Beef Lung
					</h2>
					<div class="place-img">
						<img src="{blPlace}" alt="{blAlt}" draggable="false"/>
					</div>
					<div class="quantity-img">
						<img src="{blImg}" alt="{blAlt}" draggable="false"/>
					</div>
					<button aria-label="{$beefCount == 1? 'Press spacebar to remove 1 Beef Lung Treat to your bag' : 'Press spacebar to add 1 Beef Lung Treat to your bag'}" class="check-block {$beefCount == 1? 'checked' : 'unchecked'}">
						<Icon size="50" icon="{$beefCount == 1? 'checked' : 'unchecked'}"></Icon>
					</button>
				</div>
				<div class="quantity checkboxes" in:fly="{{ y: 20, duration: 1000, delay: 75, easing: elasticOut }}" on:click="{selectSweet}">
					<h2>
						Sweet Potato
					</h2>
					<div class="place-img">
						<img src="{spPlace}" alt="{spAlt}" draggable="false"/>
					</div>
					<div class="quantity-img">
						<img src="{spImg}" alt="{spAlt}" draggable="false"/>
					</div>
					<button aria-label="{$sweetCount == 1? 'Press spacebar to remove 1 Sweet Potato Treat to your bag' : 'Press spacebar to add 1 Sweet Potato Treat to your bag'}" class="check-block {$sweetCount == 1? 'checked' : 'unchecked'}">
						<Icon size="50" icon="{$sweetCount == 1? 'checked' : 'unchecked'}"></Icon>
					</button>
				</div>
			{/if}
		{/if}
		{#if $step == 2 && $country != null}
		<div class="summary" in:fly="{{ y: 20, duration: 1000, delay: checkDelay, easing: elasticOut }}">
			<h2>
				Selected product{totalCount == 1? '' : 's'}:
			</h2>
			<ul>
				{#if $beefCount > 0}
					<CartLine name="Natural Beef Lung Dog Treat" img={blThumb} alt="Beef Lung Treat Cart Thumbnail Image" qty="{$beefCount}"></CartLine>
				{/if}
				{#if $sweetCount > 0}
					<CartLine name="Natural Sweet Potato Dog Treat" img={spThumb} alt="Sweet Potato Treat Cart Thumbnail Image" qty="{$sweetCount}"></CartLine>
				{/if}
			</ul>
			
			<table in:fly="{{ y: 20, duration: 800, delay: 20, easing: elasticOut }}">
				<tr>
					<td class="table-key">Subtotal</td>
					<td class="table-val">${price.toFixed(2)}</td>
				</tr>
				<tr>
					<td class="table-key">Shipping</td>
					<td class="table-val">{shippingCost.toFixed(2)}</td>
				</tr>
				{#if discount != 'None'}
				<tr class="discount">
					<td class="table-key">Discount</td>
					<td class="table-val">-${discountAmt.toFixed(2)}</td>
				</tr>
				{/if}
				<tr class="total">
					<td class="table-key">Total</td>
					<td class="table-val">${totalPrice.toFixed(2)}</td>
				</tr>
			</table>
				<a in:fly="{{ y: 20, duration: 1000, delay: 75, easing: elasticOut }}" href="{magicLink}" on:click={saveOrder} class="magic-button">
						{loading ? 'Loading Checkout...' : 'Proceed to Checkout'}
				</a>
				<p  in:fly="{{ y: 20, duration: 1050, delay: 95, easing: elasticOut }}" class="disclaimer">*Taxes will be calculated at checkout</p>
				<PaymentIcons accepted="{paymentMethods}"></PaymentIcons>

		</div>
		{/if}
	</main>
	{#if totalCount >= minBundle && $step == 1 && $type == 'bundle'}
		<button class="option-button main-cta" on:click="{()=> plus(step)}" in:fly="{{ y: 20, duration: 1000, delay: 75, easing: elasticOut }}">
			next
		</button>
	{/if}
	{#if totalCount > 0 && $step == 1 && $type == 'sample'}
		<button class="option-button main-cta" on:click="{upsell}" in:fly="{{ y: 20, duration: 1000, delay: 75, easing: elasticOut }}">
			next
		</button>
	{/if}
</div>